import { IconButton, Space, Text, useModal } from '@billy/design-system'
import { useCallback } from 'react'

import { ModalId } from '../../../../../../../../../../../../enums/modalId'
import { useInvoiceEditorForm } from '../../../../../../../../contexts/invoiceEditorFormContext'
import { useInvoicePrefixAndNumber } from '../../contexts/invoicePrefixAndNumberContext'
import { InvoicePrefixAndNumberModal } from './elements/InvoicePrefixAndNumberModal'
import * as Styled from './styles'

const InvoicePrefixAndNumberModalId = ModalId.InvoiceEditorInvoicePrefixAndNumberModal

export const InvoicePrefixAndNumber = () => {
  const { trackInvoiceEditor } = useInvoiceEditorForm()
  const { open: openInvoiceNumberAndPrefixModal } = useModal(InvoicePrefixAndNumberModalId)
  const { documentDisplayedTitle } = useInvoicePrefixAndNumber()

  const handleEditIconClick = useCallback(() => {
    openInvoiceNumberAndPrefixModal()
    trackInvoiceEditor('Form - Invoice number clicked')
  }, [openInvoiceNumberAndPrefixModal, trackInvoiceEditor])

  return (
    <>
      <Styled.InvoiceTitleWrapper>
        <Text nowrap truncate uppercase variant="h4" weight="bold">
          {documentDisplayedTitle}
        </Text>
        <Space horizontal size="s4" />
        <IconButton icon="squarePen" onClick={handleEditIconClick} size="md" />
      </Styled.InvoiceTitleWrapper>
      <InvoicePrefixAndNumberModal id={InvoicePrefixAndNumberModalId} />
    </>
  )
}
